<template>
  <card>
    <div class="quick-link">
      <div class="link-row">
        <div class="link" @click="company">
          <div class="link-pic company"></div>
          <div class="link-name">{{ $t("homes.company") }}</div>
        </div>
        <div class="link" @click="project">
          <div class="link-pic project"></div>
          <div class="link-name">{{ $t("homes.project") }}</div>
        </div>
      </div>
      <div class="link-row">
        <div class="link" @click="patent">
          <div class="link-pic patent"></div>
          <div class="link-name">{{ $t("homes.patent") }}</div>
        </div>
        <div class="link" @click="process">
          <div class="link-pic process"></div>
          <div class="link-name">{{ $t("homes.process") }}</div>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
export default {
  name: '',
  components: {},
  mixins: [],
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    company(){
      this.$router.push({path:'/companyManagement/companyListView'})
    },
    project(){
      this.$router.push({path:'/projectManagement/projectListView'})
    },
    patent(){
      this.$router.push({path:'/patentManagement/patentListView', query:{mainType: 1}})
    },
    process(){
      this.$router.push({path:'/generalProcessManagement/index'})
    }
  }
}
</script>
<style lang="scss" scoped>
.quick-link {
  height: 164px;

  display: flex;
  flex-wrap: wrap;
  align-content: space-around;

  .link-row {
    display: flex;
    flex-basis: 100%;
    justify-content: space-around;

    .link {
      width:80px;
      text-align: center;
      display:flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;

      .link-pic {
        width: 40px;
        height: 40px;
        background-repeat: no-repeat;
        background-position: center;
        color:white;
        padding-top: 13px;
        box-sizing: border-box;
        font-size:22px;
        background-size: contain;
      }
      .company {
        background-image: url("../../../assets/company.png");
      }
      .project {
        background-image: url("../../../assets/project.png");
      }
      .patent {
        background-image: url("../../../assets/patent.png");
      }
      .process {
        background-image: url("../../../assets/process.png");
      }

      .link-name{
        margin-top:9px;
        font-size:13px;
        color:#666666;
      }
    }
  }
}
</style>
